import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import { Role } from '@/helpers/role.js';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import Forbidden from '@/views/GeneralViews/Forbidden.vue';
import Unauthorized from '@/views/GeneralViews/Unauthorized.vue';

const Deals = () => import(/* webpackChunkName: "extra" */ '@/views/Deals/List.vue');
const Activity = () => import(/* webpackChunkName: "extra" */ '@/views/Dashboard/Dashboard.vue');

const Login = () => import(/* webpackChunkName: "dashboard" */ '@/views/Login.vue');
const VerifyToken = () => import(/* webpackChunkName: "dashboard" */ '@/views/VerifyToken.vue');

let dashboardMenu = {
  path: '/',
  component: DashboardLayout,
  name: 'Dashboard',
  children: [
    {
      path: '/dashboard',
      name: 'Activity',
      default: true,
      component: Activity,
      meta: { authorize: [Role.Admin, Role.User] } 
    },
    {
      path: '/deals',
      name: 'Deals',
      default: true,
      component: Deals,
      meta: { authorize: [Role.Admin, Role.User] } 
    },
  ]
};

let authPages = {
  path: '/login',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/verify-token',
      name: 'VerifyToken',
      component: VerifyToken
    },
    { 
      path: '/forbidden', 
      name: 'Forbidden',
      component: Forbidden 
    },
    { 
      path: '/unauthorized', 
      name: 'Unauthorized',
      component: Unauthorized 
    },
    { 
      path: '/not-found', 
      name: 'NotFound',
      component: NotFound 
    }
  ]
};

const routes = [
  dashboardMenu,
  authPages
];

export default routes;
